var map = {
	"./decidim/avatar-multiuser.png": 99213,
	"./decidim/brands/google.svg": 30224,
	"./decidim/cc-badge.png": 86203,
	"./decidim/decidim-logo.svg": 89967,
	"./decidim/default-avatar.svg": 6851,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 35721,
	"./decidim/icons.svg": 26802,
	"./decidim/pattern.png": 63505,
	"./decidim/placeholder-card-g.svg": 98110,
	"./decidim/placeholder-card-l.svg": 13557,
	"./decidim/placeholder.jpg": 76196,
	"./decidim/remixicon.symbol.svg": 37190,
	"./decidim/vendor/leaflet/layers-2x.png": 26275,
	"./decidim/vendor/leaflet/layers.png": 61082,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 37471,
	"./decidim/vendor/leaflet/marker-icon.png": 83574,
	"./decidim/vendor/leaflet/marker-shadow.png": 79149,
	"./decidim/vendor/social-share-button/douban.svg": 57833,
	"./decidim/vendor/social-share-button/email.svg": 78346,
	"./decidim/vendor/social-share-button/facebook.svg": 48802,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 74766,
	"./decidim/vendor/social-share-button/hacker_news.svg": 27146,
	"./decidim/vendor/social-share-button/linkedin.svg": 56280,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 16433,
	"./decidim/vendor/social-share-button/pinterest.svg": 89172,
	"./decidim/vendor/social-share-button/reddit.svg": 5902,
	"./decidim/vendor/social-share-button/telegram.svg": 23855,
	"./decidim/vendor/social-share-button/tumblr.svg": 10220,
	"./decidim/vendor/social-share-button/twitter.svg": 5983,
	"./decidim/vendor/social-share-button/vkontakte.svg": 53213,
	"./decidim/vendor/social-share-button/wechat.svg": 64320,
	"./decidim/vendor/social-share-button/whatsapp.svg": 44960,
	"./decidim/vendor/social-share-button/x.svg": 61930,
	"./decidim/vendor/social-share-button/xing.svg": 20574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84972;